module.exports = __webpack_public_path__ + "img/principle.0055da1a.png";